import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'codeDesignationAngular'
})
export class CodeDesignationCohabitationPipeMock implements PipeTransform {

	transform(value: any, args?: any): any {
		return value;
	}

}
